export default __webpack_public_path__ + "static/media/Twitter-46.aa06eacd.svg";